import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import { Flex, Text } from "@chakra-ui/react";

ChartJS.register(...registerables);

export default function TopAssistantsChart({ topAssistants }) {
  if (!topAssistants?.length) {
    return (
      <Flex align="center" justify="center" h="200px">
        <Text fontSize="sm" color="gray.400">No assistant usage yet</Text>
      </Flex>
    );
  }

  const config = {
    data: {
      labels: topAssistants.map((a) => a.name || "Unnamed"),
      datasets: [
        {
          label: "Text",
          data: topAssistants.map((a) => a.text_count),
          backgroundColor: "#4F46E5",
          borderRadius: 4,
        },
        {
          label: "Voice",
          data: topAssistants.map((a) => a.voice_count),
          backgroundColor: "#7C3AED",
          borderRadius: 4,
        },
      ],
    },
    options: {
      indexAxis: "y",
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: { boxWidth: 10, font: { size: 11 }, color: "#6B7280" },
        },
        tooltip: {
          callbacks: {
            label: (ctx) => ` ${ctx.dataset.label}: ${ctx.parsed.x.toLocaleString()}`,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          beginAtZero: true,
          grid: { color: "rgba(156,163,175,0.15)" },
          ticks: { color: "#9CA3AF", precision: 0 },
        },
        y: {
          stacked: true,
          grid: { display: false },
          ticks: {
            color: "#374151",
            font: { size: 11 },
            callback: (val, i) => {
              const name = topAssistants[i]?.name || "";
              return name.length > 20 ? name.slice(0, 18) + "…" : name;
            },
          },
        },
      },
    },
  };

  return (
    <div style={{ height: `${Math.max(180, topAssistants.length * 44)}px`, position: "relative" }}>
      <Bar {...config} />
    </div>
  );
}
